import { render } from "./GlobalPatientSearchModal.vue?vue&type=template&id=94c8c0f8&scoped=true"
import script from "./GlobalPatientSearchModal.vue?vue&type=script&lang=js"
export * from "./GlobalPatientSearchModal.vue?vue&type=script&lang=js"

import "./GlobalPatientSearchModal.vue?vue&type=style&index=0&id=94c8c0f8&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c8c0f8"]])

export default __exports__